import { render } from "./EnvironmentRecognitionModal.vue?vue&type=template&id=2c6afd9a&scoped=true"
import script from "./EnvironmentRecognitionModal.vue?vue&type=script&lang=js"
export * from "./EnvironmentRecognitionModal.vue?vue&type=script&lang=js"

import "./EnvironmentRecognitionModal.vue?vue&type=style&index=0&id=2c6afd9a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6afd9a"]])

export default __exports__